import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PlatformService } from '../../../services/platform/platform.service';
import { ERoutes } from '../../enums/routes.enum';

export const desktopOnlyGuard: CanActivateFn = (route, state) => {
  const platform = inject(PlatformService);
  const router = inject(Router);

  if (platform.isPlatformBrowser() && window.innerWidth > 768) {
    return true;
  }

  // On mobile: redirect to the mobile equivalent if specified in route data
  const mobileRedirect: string = route.data?.['mobileRedirect'];
  if (mobileRedirect) {
    return router.parseUrl(mobileRedirect);
  }

  // Default: redirect mobile users to the mobile inbox under the mobile chat layout
  return router.parseUrl(`/m/${ERoutes.chat}`);
};
